module.exports = __webpack_public_path__ + "644be6f20759023bb57ada5b607e2d5b.svg";